<!-- más adelante poner una condición que aparezca esta tarjeta si solo es device nuevos -->
<div class="content-wrapper" *ngIf="stackForm">
  <form [formGroup]="stackForm" size="12" class="no-padding ion-padding-top">
    <ion-grid>

      <!-- Título con icono -->
      <h5 class="stack-section-title">
        <mat-icon>memory</mat-icon>
        <span class="title-label">Configuración del Stack del Node</span>
        <!-- Badge de conectividad -->
        <div *ngIf="device?.extraInfo.isActived?.value == 'false'" class="connectivity-badge bluetooth">
          <mat-icon class="bluetooth-icon">bluetooth</mat-icon>
          <span>Bluetooth</span>
        </div>
        <div *ngIf="device?.extraInfo.isActived?.value == 'true'" class="connectivity-badge nbiot">
          <mat-icon class="nbiot-icon">settings_input_antenna</mat-icon>
          <span>NBIOT</span>
        </div>
      </h5>


      <hr>
      <div class="info-note" *ngIf="hasNewPeriods()">
        <mat-icon>info</mat-icon>
        Los cambios realizados pueden tardar&nbsp;<strong>aproximadamente {{ getEstimatedPeriod() }}
          minutos</strong>&nbsp;en aplicarse en el
        dispositivo, ya que dependen de la frecuencia con la que el dispositivo se sincroniza con el&nbsp;servidor.
      </div>

      <!-- Periodo de envío -->
      <ion-row>
        <ion-col>
          <p class="title">
            <mat-icon class="icon">schedule</mat-icon>
            Periodo de envío de datos
          </p>
        </ion-col>
      </ion-row>

      <!-- Fila del label + input -->
      <ion-row>
        <ion-col size="6" size-lg="2">
          <ion-label class="gray">Periodo envío (Min.)</ion-label>
        </ion-col>

        <ion-col class="highlight" size="6" size-lg="2">
          <ion-item>
            <ion-input type="number" min="1" formControlName="sendPeriod" (ionChange)="onSendPeriodChange()"></ion-input>
          </ion-item>
          <div *ngIf="submitted && stackForm.controls.sendPeriod.errors?.['invalidAutoCorrectionPeriod']" class="text-danger">
            El período debe ser divisor de 60 (5, 10, 15, 20, 30) o múltiplo de 60 (120, 180, 240...) para caer siempre en horas exactas
          </div>
          <div *ngIf="submitted && stackForm.controls.sendPeriod.errors && !stackForm.controls.sendPeriod.errors['invalidAutoCorrectionPeriod']" class="text-danger">
            {{ 'El valor debe ser mayor que cero' }}
          </div>
        </ion-col>
      </ion-row>

      <!-- Autocorrección de horario — solo superadmin (ni admin ni usuario
           normal); el backend aplica la misma restricción de verdad. -->
      <ng-container *ngIf="isSuperAdmin">
        <ion-row>
          <ion-col size="12">
            <ion-item lines="none" class="no-bg">
              <ion-checkbox slot="start" formControlName="enableAutoCorrection"
                (ionChange)="onAutoCorrectionToggle()"></ion-checkbox>
              <ion-label>Autocorrección a horas exactas</ion-label>
            </ion-item>
          </ion-col>
        </ion-row>

        <div class="info-note" *ngIf="autoCorrectionError">
          <mat-icon>error</mat-icon>
          No se pudo cargar la configuración de autocorrección. Inténtalo de nuevo más tarde.
        </div>

        <ng-container *ngIf="!autoCorrectionLoading && stackForm.get('enableAutoCorrection')?.value">
          <ion-row>
            <ion-col size="6" size-lg="2">
              <ion-label class="gray">{{ isDailyGrid ? 'A qué hora del día' : 'A qué minuto de cada hora' }}</ion-label>
            </ion-col>

            <ion-col class="highlight auto-correction-period-col" size="6" size-lg="2">
              <ion-item *ngIf="!isDailyGrid">
                <ion-input type="number" min="0" [max]="maxSendTime" formControlName="sendTime"></ion-input>
              </ion-item>
              <ion-item *ngIf="isDailyGrid">
                <ion-input type="time" [value]="sendTimeAsHHMM"
                  (ionChange)="onSendTimeHHMMChange($event.detail.value)"></ion-input>
              </ion-item>
              <mat-icon class="info-icon" [matTooltip]="autoCorrectionPreview">info</mat-icon>
            </ion-col>
          </ion-row>

          <ion-row *ngIf="!isDailyGrid">
            <ion-col size="12">
              <div *ngIf="submitted && stackForm.controls.sendTime.errors?.['sendTimeWrapsAround']" class="text-danger">
                Con este período, el minuto solo puede ir de 0 a {{ maxSendTime }} — valores iguales o mayores se repiten (por ejemplo, {{ maxSendTime + 1 }} equivale a 0).
              </div>
            </ion-col>
          </ion-row>
        </ng-container>
      </ng-container>

      <mat-divider class="section-divider"></mat-divider>

      <!-- Periodo por nodo -->
      <ion-row>
        <ion-col size="12">
          <p class='title'>
            <mat-icon class="icon">timeline</mat-icon>
            Configuración del node
          </p>
        </ion-col>
      </ion-row>
      <!-- Encabezado columnas -->
      <ion-row class="node-header">
        <ion-col size="4" size-lg="2">
          <strong></strong>
        </ion-col>

        <ion-col size="4" size-lg="2">
          <strong>Periodo<br>de medición (Seg.)</strong>
        </ion-col>

        <ion-col size="6" size-lg="3" *ngIf="showSondaColumn">
          <strong>Sonda</strong>
        </ion-col>
      </ion-row>


      <!-- Fila por cada nodo -->
      <ng-container *ngFor="let sensor of device?.sensors; let i = index">
        <ion-row>

          <!-- Columna info -->
          <ion-col size="4" size-lg="2">
            <ion-label class="gray">Node {{ i + 1 }}</ion-label>
            <div class="info" *ngIf="sensor.extraInfo?.hardwareId?.value">
              <small class="gray">{{ sensor.extraInfo.hardwareId.value }}</small>
            </div>
          </ion-col>

          <!-- Periodo -->
          <ion-col size="4" size-lg="2">
            <ion-item>
              <ion-input type="number" min="60" [formControlName]="'node' + (i + 1)">
              </ion-input>
            </ion-item>

            <div *ngIf="submitted && stackForm.controls['node' + (i + 1)]?.errors" class="text-danger">
              El valor debe ser mayor o igual que 60
            </div>
          </ion-col>

          <!-- Sonda -->
          <ion-col size="6" size-lg="3" *ngIf="showSondaColumn">
            <ion-item lines="none" class="full-width-item">
              <ion-select interface="popover" placeholder="Sonda" [formControlName]="'sonda' + (i + 1)">

                <ion-select-option *ngFor="let s of availableSensors[i] || []" [value]="s.id">
                  {{ s.name }}
                </ion-select-option>


              </ion-select>
            </ion-item>
          </ion-col>

        </ion-row>
      </ng-container>



      <ion-row>
        <ion-col size="12" class="align-end">
          <button type="button" mat-raised-button color="primary" (click)="onSubmit()" class="save "
            [disabled]="isBluetoothMode || !hasFormChanged()|| stackForm.invalid">
            Solicitar actualización
          </button>

        </ion-col>
      </ion-row>
    </ion-grid>
  </form>
</div>